var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_1710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0787 7.91406H7.92188V21.0677H21.0787V7.91406Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92188 7.93968C7.92188 4.28588 10.871 1.31836 14.5003 1.31836C16.3181 1.31836 17.9642 2.06183 19.1528 3.25646C19.4515 3.56148 19.7248 3.89191 19.96 4.2414",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0787 21.0674C21.0787 24.7212 18.1359 27.6824 14.5003 27.6824C10.8647 27.6824 7.92188 24.7212 7.92188 21.0674",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 7.92578C24.7201 7.92578 27.682 10.8679 27.682 14.5026C27.682 18.1374 24.7201 21.0795 21.0654 21.0795",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24111 19.9611C2.47416 18.7792 1.31738 16.7712 1.31738 14.5026C1.31738 12.6853 2.05467 11.0395 3.25594 9.85118C4.45086 8.6629 6.10976 7.92578 7.93391 7.92578",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0914 11.0215H10.9092V18.202H18.0914V11.0215Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9092 14.6113H18.0914",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93444 21.0671V21.0798C7.93444 22.1855 7.02554 23.0814 5.91961 23.0814C4.81368 23.0814 3.91113 22.1791 3.91113 21.0671C3.91113 20.6541 4.0319 20.2728 4.24164 19.9614C4.59757 19.4149 5.2141 19.0527 5.91961 19.0527C7.0319 19.0527 7.93444 19.9551 7.93444 21.0671Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0804 5.92451C23.0804 7.03018 22.1843 7.93251 21.0783 7.93887H21.0656C19.9533 7.93887 19.0508 7.03654 19.0508 5.92451C19.0508 5.21917 19.4131 4.60279 19.9597 4.24059C20.2775 4.03089 20.6588 3.91016 21.0656 3.91016C22.1779 3.91016 23.0804 4.81249 23.0804 5.92451Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_1710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner2);
export default __webpack_public_path__ + "static/media/banner2.25f8d751328d596d761aa01e378e0337.svg";
export { ForwardRef as ReactComponent };